export default __webpack_public_path__ + "static/media/mapStat1Legend.7b02c83b.svg";